var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"app":"","clipped-left":_vm.$vuetify.breakpoint.mdAndUp,"color":"white","fixed":""}},[_c('v-toolbar-title',[_c('img',{attrs:{"src":require("@/assets/img/logo_new.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }